<i18n src="./translations"></i18n>

<template>
  <div>
    <p v-if="!showUpToDiscountedPrice" class="price-business-customer__netto">
      {{ netPrice }}
      <span class="price-business-customer__label">
        {{ $t('price-business-customer.net') }}
      </span>
    </p>

    <PriceDiscounted
      v-else
      :price-texts="product.priceTexts"
      :unit-prices="product.unitPrices"
      :prices="product.prices"
    />

    <p class="price-business-customer__taxes">
      {{ product.priceTexts.tax }}&#37;
      {{ $t('price-business-customer.tax_text_excluding') }}

      <span class="price-business-customer__gross">
        <span class="price-business-customer__gross-price">{{
          grossPrice
        }}</span>

        <span class="price-business-customer__label-gross">
          {{ $t('price-business-customer.gross') }},
        </span>
      </span>

      <MaskedLink
        class="shipping"
        :text="$t('price-business-customer.shipping')"
        :redirect-to="frontFacingPath('content.page.shipping')"
      />
    </p>
  </div>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';
import MaskedLink from 'Components/01-atoms/masked-link/MaskedLink';
import PriceDiscounted from 'Components/01-atoms/price-discounted/PriceDiscounted';
import { mapState } from 'vuex';

export default {
  name: 'PriceBusinessCustomer',
  components: { MaskedLink, PriceDiscounted },
  mixins: [globalMixin],
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('renderingSalesChannelConfig', {
      isU2dAktionEnabled: ({ isU2dAktionEnabled }) => isU2dAktionEnabled,
    }),
    showUpToDiscountedPrice() {
      const priceTexts = this.product?.priceTexts;
      const discountedSalesValueGross = priceTexts?.discountedSalesValueGross;
      const upToDiscountPercentage = priceTexts?.upToDiscountPercentage;

      return (
        discountedSalesValueGross &&
        discountedSalesValueGross !== 0 &&
        upToDiscountPercentage &&
        upToDiscountPercentage > 0 &&
        this.isU2dAktionEnabled
      );
    },
    netPrice() {
      if (this.product.unitPrices && this.product.unitPrices.length > 1) {
        return this.product.unitPrices[1].price;
      }
      return '';
    },
    grossPrice() {
      if (this.product.unitPrices && this.product.unitPrices.length > 0) {
        return this.product.unitPrices[0].price;
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';
@import 'mixins';

.price-business-customer__netto {
  color: var(--color-nero);
  font-size: var(--font-size-ML);
  font-weight: bold;
  margin-bottom: var(--space-1);
}

.price-business-customer__label {
  font-size: var(--font-size-M);
  font-weight: normal;
}

.price-business-customer__gross {
  color: var(--color-nero);
  font-weight: bold;
}

.price-business-customer__label-gross {
  font-size: var(--font-size-SM);
  font-weight: normal;
}

.price-business-customer__taxes {
  font-size: var(--font-size-SM);
  color: var(--color-hippo-darker);
  font-weight: normal;
}

.shipping {
  text-decoration: underline;
}
</style>
